import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingCategory(props) {

  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const categories = [
    "Clothing > Shoes > Running Shoes",
    "Sports > Running > Shoes",
    "Fashion > Men > Shoes",
  ];

  const filtered = categories.filter((c) =>
    c.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <Container>
      <Row>

        <Col md={12} className="mt-4 mb-3">
          <h4>Step 3 : Category</h4>
        </Col>

        <Col md={12} className="ml-4 mr-4">
          <Card className="p-4">

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Search : </Col>
              <Col md={8} className="d-flex justify-content-end align-items-end">
                <Input
                  placeholder="Search Category..."
                  value={searchText}
                  onChange={(e)=>setSearchText(e.target.value)}
                  className="w-50"
                />
              </Col>
            </Row>

            {filtered.map((cat,i)=>(
              <Card
                key={i}
                className={`p-2 mb-2 ${selectedCategory===cat?"border-primary":""}`}
                onClick={()=>setSelectedCategory(cat)}
                style={{cursor:"pointer"}}
              >
                {cat}
              </Card>
            ))}

          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>Back</button>
          <button className="btn btn-primary"  onClick={props.nextStep}>Next</button>
        </Col>

      </Row>
    </Container>
  );
}

export default ProductListingCategory;